import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { useEffect } from "react";
import { useGetLocationsQuery } from "services/api/warehouseApi";
import { setLocations, Location } from "store/Slices/locationSlice";
import { useAppDispatch } from "./StoreHooks";

export function useLocations(
  defaultLocation?: Location,
  initialLocations?: Location[]
): {
  isLoading: boolean;
  error: FetchBaseQueryError | undefined;
} {
  const dispatch = useAppDispatch();

  const {
    data: fetchedLocations,
    isLoading,
    isFetching,
    error: queryError,
  } = useGetLocationsQuery();

  useEffect(() => {
    if (initialLocations) {
      dispatch(setLocations(initialLocations));
    } else if (fetchedLocations) {
      dispatch(
        setLocations(
          defaultLocation
            ? [defaultLocation].concat(fetchedLocations.locations)
            : fetchedLocations.locations
        )
      );
    }
  }, [
    dispatch,
    fetchedLocations,
    queryError,
    defaultLocation,
    initialLocations,
  ]);
  return {
    isLoading: isLoading || isFetching,
    error: queryError ? (queryError as FetchBaseQueryError) : undefined,
  };
}
